import { Order } from '@apis/index'
import Button from '@components/button'
import Empty from '@components/empty'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import HistoryInfo from '../components/historyInfo'
import HistoryLoading from '../loader/historyLoading'
import { IBookHistory } from '../type'
import { BookList } from '../style'
import { Actions, store } from '@store/index'

const LendHistory = ({
  active,
  handleClickItem,
}: {
  active: 'Lend' | 'Borrow'
  handleClickItem: (item: any, type: 'Lend') => void
}) => {
  const {
    items: lends,
    loading,
    page,
    totalPages,
  } = useSelector((state: any) => state.lendOrder)
  const [isFetching, setIsFetching] = useState<boolean>(false)
  const [params, setParams] = useState({
    page: 1,
    limit: 10,
    type: 'Lend',
  })
  const fetchHistory = async (action: any, params: any) => {
    await Order.getAll(action, 'lendOrder', params).catch(() => {})
  }
  useEffect(() => {
    if (active === 'Lend') {
      fetchHistory('set', params)
    }
    return () => {
      store.dispatch(Actions.reset('lendOrder'))
    }
  }, [])

  return (
    <>
      {loading ? (
        <HistoryLoading />
      ) : !loading && !lends.length ? (
        // <div
        //   style={{
        //     display: 'flex',
        //     flexDirection: 'column',
        //     justifyContent: 'center',
        //     alignItems: 'center',
        //     height: 'calc(100vh - 184px)',
        //   }}
        // >
        <Empty src="noBook" title="No books lent yet!" />
      ) : // </div>
      !!lends.length ? (
        <>
          <BookList>
            {lends?.map((item: IBookHistory, index: number) => (
              <HistoryInfo
                key={index.toString()}
                history={item}
                type={active}
                onClick={(history) => {
                  handleClickItem(history, 'Lend')
                }}
              />
            ))}
            {!!isFetching && <HistoryLoading />}
          </BookList>
        </>
      ) : null}
      {page < totalPages && lends.length > 0 && (
        <Button
          title="Load More..."
          type="button"
          styleButton="width: fit-content; margin: 16px auto;"
          onClick={async () => {
            const updateParams = {
              ...params,
              page: params?.page + 1,
            }

            if (updateParams?.page <= totalPages) {
              setIsFetching(true)
              await fetchHistory('append', updateParams)
                .then(() => {
                  setParams(updateParams)
                })
                .catch(() => {})
                .finally(() => {
                  setIsFetching(false)
                })
            }
          }}
        />
      )}
    </>
  )
}

export default LendHistory
